import React from "react";
import { Grid } from "@mui/material";
import { ProductShortened, SearchTextParamName } from "types";
import { ExpansionFilterAvailable } from "modules/shared/filters/ExpansionFilterAvailable";
import { SearchTextFilter } from "modules/shared/filters/SearchTextFilter";
import useStyles from "./styles";

type ProductToBuyListFilterProps = {
  productList: ProductShortened[];
};

export const ProductToBuyListFilter: React.FC<ProductToBuyListFilterProps> = ({
  productList,
}) => {
  const { classes } = useStyles();

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      className={classes.pricelistFilter}
    >
      <Grid item>
        <ExpansionFilterAvailable productList={productList} />
      </Grid>
      <Grid item>
        <SearchTextFilter
          searchTextParamName={SearchTextParamName.SearchProductToBuy}
          placeholder="Karte suchen..."
        />
      </Grid>
    </Grid>
  );
};
